var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { EnvironmentService, HttpCacheType, HttpMethodType, HttpContentType, HttpHeaderType, handleResponse, HttpStatusCode } from "../../common";
import { API_PREFIX } from '../constants/BrandedNotificationConstant';
export class BrandedNotificationGetService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    getBrandedNotificationConfiguration(brandedNotificationInputs, coCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().apdApiGatewayRoot}${API_PREFIX}${coCode}/notification-themes/details`;
            const request = new Request(uri, {
                method: HttpMethodType.POST,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    accept: HttpContentType.APPLICATION_JSON,
                    Pragma: HttpCacheType.NO_CACHE
                }),
                body: JSON.stringify(brandedNotificationInputs)
            });
            return this.fetchWrapper(request).then(response => {
                if (response.status === 200) {
                    return handleResponse(response);
                }
                else if (response.status === 204) {
                    return {};
                }
                else {
                    return Promise.reject(`${response.status} : ${response.statusText}`);
                }
            });
        });
    }
    getBrandedNotificationSummary(brandedNotificationInputs, coCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().apdApiGatewayRoot}${API_PREFIX}${coCode}/theme-templates`;
            const request = new Request(uri, {
                method: HttpMethodType.POST,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    accept: HttpContentType.APPLICATION_JSON,
                    Pragma: HttpCacheType.NO_CACHE
                }),
                body: JSON.stringify(brandedNotificationInputs)
            });
            return this.fetchWrapper(request).then(response => {
                if (response.status === 200) {
                    return handleResponse(response);
                }
                else if (response.status === 204) {
                    return {};
                }
                else {
                    return Promise.reject(`${response.status} : ${response.statusText}`);
                }
            });
        });
    }
    getCategories(companyCode, languageCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().apdApiGatewayRoot}${API_PREFIX}${companyCode}/language/${languageCode}/categories`;
            const request = new Request(uri, {
                method: HttpMethodType.GET,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    Pragma: HttpCacheType.NO_CACHE
                })
            });
            return this.fetchWrapper(request).then(response => {
                if (response.status === HttpStatusCode.OK) {
                    return handleResponse(response);
                }
                else if (response.status === HttpStatusCode.NoContent) {
                    return [];
                }
                else {
                    return Promise.reject(`${response.status} : ${response.statusText}`);
                }
            });
        });
    }
}
//# sourceMappingURL=BrandedNotificationGetService.js.map